import { IPersona, ISimulation, ISimulationScore } from '@/types';
import { mapSimulationToRoleplayCard } from '@/utils';
import { RoleplayCard, RoleplayCardProps } from '@/components';
import React, { MouseEvent } from 'react';

interface Props {
  isLoading: boolean;
  onClick: (simulation: ISimulation) => (event?: MouseEvent<HTMLButtonElement>) => void;
  onShareWithManager: RoleplayCardProps['onShareWithManager'];
  onViewScoreCard: RoleplayCardProps['onViewScoreCard'];
  personas: IPersona[];
  scores: ISimulationScore[];
  simulations: ISimulation[];
  userId?: string;
}

/**
 * CertificationSimulationsRoleplays is responsible for rendering a list of roleplay
 * cards based on the provided simulations, personas, and scores. It utilizes the
 * `mapSimulationToRoleplayCard` utility to transform each simulation into the
 * appropriate props for the `RoleplayCard` component.
 */
export const CertificationSimulationsRoleplays: React.FC<Props> = ({
  isLoading,
  onClick,
  onShareWithManager,
  onViewScoreCard,
  personas,
  scores,
  simulations,
  userId,
}) => {
  return (
    <div className="p-6">
      <div className="space-y-3">
        {simulations?.map((simulation, index) => (
          <RoleplayCard
            key={`simulation-${simulation.id}-${index}`}
            {...mapSimulationToRoleplayCard({
              simulation,
              personas,
              scores,
              onClick: onClick(simulation),
            })}
            index={index}
            isLoading={isLoading}
            onShareWithManager={onShareWithManager}
            onViewScoreCard={onViewScoreCard}
            userId={userId}
          />
        ))}
      </div>
    </div>
  );
};
